import { useSelector } from "react-redux"
import styled from "styled-components"
import KayitliAdreslerimInput from "../sections/yukleme/inputs/KayitliAdreslerimYuklemeInput"
import BosaltmaAdresTarifiInput from "../sections/bosaltma/inputs/location/BosaltmaAdresTarifiInput"
import BosaltmaAdresInput from "../sections/bosaltma/inputs/location/BosaltmaAdresInput"
import BosaltmaDateInput from "../sections/bosaltma/inputs/others/BosaltmaDateInput"
import BosaltmaEnGecDateInput from "../sections/bosaltma/inputs/others/BosaltmaEnGecDateInput"
import BosaltmaTimeRangeInput from "../sections/bosaltma/inputs/others/BosaltmaTimeRangeInput"
import BosaltmaAllTimeCheckbox from "../sections/bosaltma/inputs/others/BosaltmaAllTimeCheckbox"
import RouteLine from "../sections/shared/others/RouteLine"
import KayitliAdreslerimYuklemeInput from "../sections/yukleme/inputs/KayitliAdreslerimYuklemeInput"
import BosaltmaCityTownInput from "../sections/bosaltma/inputs/location/BosaltmaCityTownInput"
import AddRoute from "../sections/shared/others/AddRoute"
import KayitliAdreslerimeEkleCheckbox from "../sections/shared/inputs/KayitliAdreslerimeEkleCheckbox"
import BosaltmaBicimiInput from "../sections/bosaltma/inputs/others/BosaltmaBicimiInput"
import {MdKeyboardArrowRight, MdKeyboardArrowLeft} from "react-icons/md"
import BtnOutline from "../../shared/button/BtnOutline"
import { scrollToTop } from "../../../helper/scrollToTop"
import { setPermissionData } from "../../../features/addLoad/addLoadSlice"
import { useDispatch } from "react-redux"
import { showModal, showNestedModal } from "../../../features/modal/modalSlice"
import KayitliAdreslerimeEkleNameInput from "../sections/shared/inputs/KayitliAdreslerimeEkleNameInput"
import { setRoutePermissionData, setSelectedRouteItemTypeUpdate, setSelectedRouteItemUpdate } from "../../../features/updateLoad/updateLoadSlice"


const Container = styled.div`
    width: auto;

    .route-list{
        display: flex;
        flex-direction: column;
        width: auto;

        .route-item{
            width: auto;
            display: flex;

            .form-side{
                display: flex;
                flex-direction: column;
                margin-left: 6px;

                .item-top{
                    padding-left: 3px;
                    border-bottom: 1px solid ${({theme}) => theme.mainTextColor};
                    padding-bottom: 2px;
                    display: flex;
                    justify-content: space-between;


                    h4{
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-xl);
                    }

                    .delete-btn{
                        padding: 4px 14px;
                        border-radius: 5px;
                        background-color: ${({theme}) => theme.secondaryBgColor};
                        font-size: var(--font-size-sm);
                        font-size: 12px;
                        font-weight: var(--font-weight-lg);
                        cursor: pointer;

                        &:hover{
                            background-color: ${({theme}) => theme.mainTextColor};
                            color: ${({theme}) => theme.mainBgColor};
                        }
                    }
                }


                .input-list{
                    display: flex;
                    flex-direction: column;
                    padding-left: 20px;
                    padding-top: 20px;
                    gap: 20px;
                    margin-bottom: 40px;

                    .grp{
                        display: flex;
                        align-items: center;
                        gap: 10px;

                        .redirect-span{
                            font-size: var(--font-size-sm);
                            font-size: 12px;
                            font-weight: var(--font-weight-lg);
                            display: flex;
                            align-items: center;
                            gap: 5px;
                            cursor: pointer;
                        }
                    }

                    .grp-top-aligned{
                        display: flex;
                        align-items: flex-start;
                        gap: 10px;

                        .google-adres-container{
                            width: auto;
                            width: 300px;
                            height: 54px;
                            background-color: ${({ theme }) => theme.secondaryBgColor};
                            border: 1px solid ${({ theme }) => theme.mainBorderColor};
                            font-size: 12px;
                            font-weight: var(--font-weight-md);
                            border-radius: 5px;
                            padding: 5px 10px;
                            display: flex;
                            flex-direction: column;
                            gap: 5px;

                            .google-adres-top{
                                font-weight: var(--font-weight-lg);
                                text-decoration: underline;
                            }

                            .google-adres{
                                width: 100%;
                            }
                        }
                    }
                }


            }

        }
    }

    .bottom-btn-container{
        width: 100%;
        padding: 50px;
        display: flex;
        justify-content: space-between;

        .icon{
            fill: var(--color-main);
            font-size: 1.6rem;
        }

        span{
            color: ${({theme}) => theme.mainTextColor};
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-xl);
        }

    }

`

const BosaltmaSection = ({setPhase, bosaltmaDataList, kayitGuncelle}) => {

    const dispatch = useDispatch()
    const {theme} = useSelector(state => state.layout)
    
  return (
    <Container>
        <div className="route-list">
            {
                bosaltmaDataList.map((item, i) => (
                    <div className="route-item">
                        <RouteLine type={i === 0 ? "start" : "mid"}/>
                        <div className="form-side">
                            <div className="item-top">
                                <h4 className="h4">{bosaltmaDataList.length > 1 && i+1 + "."} Boşaltma {item.locationData.location && `(${item?.locationData?.location})`} </h4>
                                {
                                    bosaltmaDataList.length > 1 &&
                                    <button className="delete-btn" onClick={() =>{dispatch(showNestedModal("deleteLoadRoutePermissionNested")); dispatch(setRoutePermissionData(item))}}>Sil</button>
                                }
                            </div>
                            <div className="input-list">
                                <KayitliAdreslerimYuklemeInput itemForKayitliAdres={item} name={`kayitliAdreslerimBosaltmaInput${item.id}`} />
                                <div className="grp">
                                    <BosaltmaCityTownInput data={item} name={"bosaltmaCityTown"+item.id} isRequired={true} />
                                    {/* <span onClick={() => {
                                        dispatch(showNestedModal("singleRouteMapUpdate"));
                                        dispatch(setSelectedRouteItemUpdate(item))
                                        dispatch(setSelectedRouteItemTypeUpdate(false))
                                        }}
                                        className="redirect-span"
                                        >
                                        <svg
                                        className="redirect"
                                        width="17"
                                        height="19"
                                        viewBox="0 0 17 19"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        >
                                        <path
                                            d="M0 11.5C0 7.36 3.36 4 7.5 4H10V0L17 6L10 12V8H7.5C5.57 8 4 9.57 4 11.5V19H0V11.5Z"
                                            fill={theme === "dark" ? "#f4f4f4" : "#3D3D3B"}
                                        />
                                        </svg>
                                        Haritadan Konum Seç
                                    </span> */}
                                </div>
                                <div className="grp-top-aligned">
                                    <BosaltmaAdresInput data={item} name={"bosaltmaAdres"+item.id} isRequired={true}/>
                                    {
                                        item.locationData.googleLocation &&
                                        <div className="google-adres-container">
                                            <div className="google-adres-top">Seçilen Adres</div>
                                            <div className="google-adres">{item.locationData.googleLocation}</div>
                                        </div>
                                    }
                                </div>
                                <div className="grp-top-aligned">
                                    <BosaltmaAdresTarifiInput data={item} name={"bosaltmaAdresTarif"+item.id} isRequired={false}/>
                                    <BosaltmaBicimiInput data={item} name={"bosaltmaBicimi"+item.id} isRequired={false}/>
                                </div>
                                <div className="grp">
                                    <BosaltmaDateInput data={item} name={"bosaltmaDate"+item.id} isRequired={true} />
                                    <BosaltmaEnGecDateInput  data={item} name={"bosaltmaDateEngec"+item.id} isRequired={false}/>
                                </div>
                                <div className="grp">
                                    <BosaltmaTimeRangeInput data={item} name={"bosaltmaSaat"+item.id} isRequired={false}/>
                                    <BosaltmaAllTimeCheckbox data={item} name={"bosaltmaSaatAllTime"+item.id} isRequired={false}/>
                                </div>
                                {!kayitGuncelle &&
                                    <div className="grp">
                                        <KayitliAdreslerimeEkleCheckbox data={item} name={"addressKayit" + item.id}/>
                                    </div>
                                }
                                
                                {
                                    item.adresKaydedilsinMi &&
                                    <div className="grp">
                                        <KayitliAdreslerimeEkleNameInput data={item} name={"addressKayitName" + item.id} isRequired={item.adresKaydedilsinMi}/>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                ))
            }
            <AddRoute order={bosaltmaDataList.length +1} type="bosaltma"/>
        </div>
        <div className="bottom-btn-container">
            <BtnOutline height={"40px"} width={"120px"} radius={"10px"} handleClick={() => {setPhase({id: 1, name:"Yükleme"});scrollToTop()}} >
                <MdKeyboardArrowLeft className="icon"/>
                <span>Yükleme</span>
            </BtnOutline>
            <BtnOutline height={"40px"} width={"120px"} radius={"10px"}handleClick={() => {setPhase({id: 3, name:"Rota Planlama"});scrollToTop()}}  >
                <span>Rota Planlama</span>
                <MdKeyboardArrowRight className="icon"/>
            </BtnOutline>
        </div>
    </Container>
  )
}

export default BosaltmaSection
